import React from 'react';
import { IntercomProvider as ReactIntercomProvider } from 'react-use-intercom';
import IntercomManager from './IntercomManager';

interface IntercomProviderProps {
	children: React.ReactNode;
}

const intercomAppId = import.meta.env.REACT_APP_INTERCOM_APP_ID ?? '';

/**
 * IntercomProvider is a wrapper component that provides the Intercom context to its children.
 * @param children - The children
 * @returns
 */
export const IntercomProvider: React.FC<IntercomProviderProps> = ({
	children,
}) => {
	if (import.meta.env.NODE_ENV === 'test') return children;

	return (
		<ReactIntercomProvider appId={intercomAppId}>
			<IntercomManager />
			{children}
		</ReactIntercomProvider>
	);
};
